import PropTypes from 'prop-types';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { changeMultipleStatus, deleteMultipleProp } from 'redux/propsSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import messageHandler from 'utils/messageHandler';

const ActionsModal = ({
  selected,
  setSelected,
  setShow,
  setCheckChanges,
  status,
  actionName,
  modalMsg,
  actionTitle
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const HandleClose = () => setShow(false);

  const HandleAction = async () => {
    let selectedFiltered = [];

    // Filter actions by status to avoid errors (like trying to publish a pending property)
    if (status === 'published') {
      selectedFiltered = selected.filter(prop => prop.status === 'Pausada');
    }
    if (status === 'paused') {
      selectedFiltered = selected.filter(
        prop => prop.status === 'Activa' || prop.status === 'Pausada'
      );
    }
    if (status === 'finished') {
      selectedFiltered = selected.filter(prop => prop.status !== 'Pendiente');
    }
    if (status === 'deleted') {
      selectedFiltered = selected;
    }

    // Generate a promise array with the results of the actions
    const promises = await Promise.allSettled(
      selectedFiltered.map(async prop => {
        if (status === 'deleted') {
          const res = await dispatch(deleteMultipleProp(prop.id));
          return res;
        } else {
          const res = await dispatch(changeMultipleStatus(prop.id, status));
          return res;
        }
      })
    );

    // Generate a message with the results of the actions
    const success = promises.filter(
      promise => promise.status === 'fulfilled'
    ).length;
    const filtered = selected.length - selectedFiltered.length;

    // Generate a message with the results of the actions
    const message = (
      <div>
        {!(selected.length === success) && (
          <p>{`Se procesaron ${selected.length} propiedades.`}</p>
        )}
        <p>{`${success} propiedades fueron ${actionName} correctamente.`}</p>
        {!(selected.length === success) && (
          <p>{`Un total de ${
            selectedFiltered.length - success + filtered
          } propiedades no pudieron ser ${actionName}.`}</p>
        )}
      </div>
    );

    // Reset the selected array and force to update prop list
    setSelected([]);
    setCheckChanges(true);

    // Finally, show message and close modal
    messageHandler('success', message);
    HandleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={HandleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{`${actionTitle} propiedades`}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4" style={{ color: '#4a4949' }}>
          Las <strong>{selected.length} propiedades </strong> seleccionadas{' '}
          {modalMsg}
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?
        </div>
        <ModalButtonsContainer>
          <ButtonClose text="Cancelar" funcion={HandleClose} />
          <ButtonAccept
            text={loading ? 'Cargando...' : actionTitle}
            funcion={() => {
              setLoading(true);
              setTimeout(() => {
                HandleAction();
              }, [1000]);
            }}
            disabled={loading}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

ActionsModal.propTypes = {
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired,
  setCheckChanges: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  actionName: PropTypes.string.isRequired,
  modalMsg: PropTypes.string.isRequired,
  actionTitle: PropTypes.string.isRequired
};

export default ActionsModal;
